import { withInstall } from '@vuesax-alpha/utils'
import Tooltip from './src/tooltip.vue'

export const VsTooltip = withInstall(Tooltip)
export default VsTooltip

export * from './src/tooltip'
